import { ModelID, SearchParams, Task } from '@/types';

export type Filter = 'all' | 'active' | 'inactive';
export type Sort = 'created_at' | 'updated_at' | 'task_id';
export interface TaskSearchParams extends SearchParams<Filter, Sort>, Partial<Task> {}

export const featurePath = '/v4/tasks';

export const featureKeys = {
  all: [{ scope: 'tasks' }] as const,

  lists: (location: ModelID) => [{ ...featureKeys.all[0], location, entity: 'list' }] as const,

  list: (location: ModelID, search: TaskSearchParams = {}) =>
    [{ ...featureKeys.lists(location)[0], search }] as const,

  details: () => [{ ...featureKeys.all[0], entity: 'detail' }] as const,

  detail: (id: ModelID) => [{ ...featureKeys.details()[0], id }] as const,
};
